import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import SafeAnchorOffset from 'components/SafeAnchorOffset/SafeAnchorOffset';

import Container from './components/Container/Container';
import HeadingBlock from './components/HeadingBlock/HeadingBlock';
import ImageBlock from './components/ImageBlock/ImageBlock';
import FormBlock from './components/FormBlock/FormBlock';
import { StyledSection } from './styles/Section';

const ProductPageOpenFormSection = forwardRef(({ children, className }, ref) => (
  <StyledSection ref={ref} className={className}>
    <SafeAnchorOffset id="quero-ser-cliente" />
    {children}
  </StyledSection>
));

ProductPageOpenFormSection.Container = Container;
ProductPageOpenFormSection.Heading = HeadingBlock;
ProductPageOpenFormSection.ImageBlock = ImageBlock;
ProductPageOpenFormSection.FormBlock = FormBlock;

ProductPageOpenFormSection.defaultProps = {
  className: undefined,
};

ProductPageOpenFormSection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ProductPageOpenFormSection;
